import { Grid, Typography, Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import React from 'react';

VMDiskSettings.propTypes = {
  currentVM: PropTypes.object,
  updateCurrentVM: PropTypes.func
};

// eslint-disable-next-line no-unused-vars
export function VMDiskSettings({ currentVM, updateCurrentVM }) {
  return (
    <Grid xs={12}>
      <Accordion disabled>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Disk Settings</Typography>
        </AccordionSummary>
        <AccordionDetails>{/* content here */}</AccordionDetails>
      </Accordion>
    </Grid>
  );
}
